import React from 'react';
import { Icon } from './Icon.js';
export const IconGripDotsVerticalFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("circle", { cx: "6.75", cy: "9", r: "1.25", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "6.75", cy: "3.75", r: "1.25", fill: "currentColor" }),
        React.createElement("circle", { cx: "6.75", cy: "14.25", r: "1.25", fill: "currentColor" }),
        React.createElement("circle", { cx: "11.25", cy: "9", r: "1.25", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "11.25", cy: "3.75", r: "1.25", fill: "currentColor" }),
        React.createElement("circle", { cx: "11.25", cy: "14.25", r: "1.25", fill: "currentColor" })));
};
//# sourceMappingURL=IconGripDotsVerticalFill18.js.map